import { FileRoutes } from '@solidjs/start/router';
import { MetaProvider } from '@solidjs/meta';
import { clientOnly } from '@solidjs/start';
import { Setting, setting, SusRootProvider } from '@bz/request';
import { UserContext } from '@bz/common';
import tracker, { EmitEvent } from '@bz/tracker';
import { useInviteCodeStore } from '@bz/account/src/stores/inviteCodeStore';

import { initSession } from './hook/initSession';
import { loginBeforeRoute, loginGuard } from './utils/loginGuard';
import { useSIR } from './hook/useSIR';
import { SliderCaptchaProvider } from './components/SliderCaptcha';
import './styles/index.css';

const ParabolaAnimation = clientOnly(() =>
  import('./components/ParabolaAnimation').then((m) => ({ default: m.ParabolaAnimation }))
);

export default function App() {
  useSIR(false);

  onMount(() => {
    initSession();
  });

  createEffect(() => {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      sessionStorage.setItem('userRegisterSourceLink', location.href);
    }
    let ic = '';
    let ch = '';
    let pd = '';

    // 1. 尝试从 location.search 解析 (针对 /r?ic=TA9RTKUKH7 场景)
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has('ic')) ic = searchParams.get('ic') || '';
    if (searchParams.has('ch')) ch = searchParams.get('ch') || '';
    if (searchParams.has('pd')) pd = searchParams.get('pd') || '';

    // 2. 尝试从 location.hash 解析 (针对 #/hshshs2222?ch=Google 场景)
    const hash = location.hash;
    let hashPath = hash;
    if (hash.includes('?')) {
      const parts = hash.split('?');
      hashPath = parts[0] || '';
      const hashSearchParams = new URLSearchParams(parts[1] || '');
      if (!ic && hashSearchParams.has('ic')) ic = hashSearchParams.get('ic') || '';
      if (!ch && hashSearchParams.has('ch')) ch = hashSearchParams.get('ch') || '';
      if (!pd && hashSearchParams.has('pd')) pd = hashSearchParams.get('pd') || '';
    }

    // 3. 从 hash 路径中提取邀请码 (例如 #/hshshs2222)
    const inviteCodeMatch = hashPath.match(/^#\/([A-Za-z0-9]+)$/);
    if (inviteCodeMatch) {
      if (!ic) ic = inviteCodeMatch[1];
    }

    // 4. 设置全局邀请码
    if (ic) {
      useInviteCodeStore.setGlobalInviteCode(ic);
    }

    console.log('search ic:', ic);
    console.log('search ch:', ch);
    console.log('search pd:', pd);

    // 5. 上报买量数据
    if (ic) {
      tracker.emit([
        {
          properties: {
            guest_channel_from: ch || null,
            invite_code: ic || null,
            pixel_id: pd || null,
          },
          event: EmitEvent.INVITE_LINK_JUMP,
        },
      ]);
    }

    document.documentElement.dataset.theme = Setting.Theme[setting.theme] || Setting.Theme[Setting.Theme.bakos];
  });

  return (
    <MetaProvider>
      <ParabolaAnimation />
      <Application
        routes={((<FileRoutes />) as RouteDefinition[]).map((route) => loginGuard(route))}
        beforeRoute={loginBeforeRoute}
        root={(props) => props.children}
        config={{
          i18n: { confirm: t('Confirm'), cancel: t('Cancel') },
          icons: {
            close: IconCloseMark,
            success: IconCheckSuccess,
            error: IconDelete,
            arrow: IconArrow06,
          },
        }}
      >
        {(props) => {
          return (
            <CustomErrorBoundary>
              <SusRootProvider>
                <UserContext>
                  {props.children}
                  <SliderCaptchaProvider />
                </UserContext>
              </SusRootProvider>
            </CustomErrorBoundary>
          );
        }}
      </Application>
    </MetaProvider>
  );
}
